export default __webpack_public_path__ + "static/media/location.2d1a67bc.svg";